import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useContext } from "react";
import { DialogProvider, createDialogContext } from "../../../Common/Dialog";

export const DeleteScheduledUpdateDialogContext = createDialogContext();

const DeleteScheduledUpdateDialog = ({
  isLoading = false,
}: {
  isLoading: boolean;
}) => {
  const { isOpen, text, title, actions } = useContext(
    DeleteScheduledUpdateDialogContext
  );

  const _onClose = () => {};

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={_onClose}
        isCentered
      >
        <ModalOverlay />
        <ModalContent
          mb={[0, "auto"]}
          borderBottomLeftRadius={[0, "md"]}
          borderBottomRightRadius={[0, "md"]}
        >
          <ModalHeader paddingTop={4}>
            <VStack gap={0} width={"full"}>
              <Text w="full">{title}</Text>
            </VStack>
          </ModalHeader>
          <ModalBody textAlign={"left"}>
            <VStack w="full">
              <Text w="full">{text}</Text>
              <Text color="red.500" w="full">
                This deletion cannot be undone.
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Stack direction={["column-reverse", "row-reverse"]} width="100%">
              {actions.map((action, index) => (
                <Button
                  key={index}
                  onClick={action.onClick}
                  variant={action.type}
                  isLoading={isLoading}
                  isDisabled={isLoading}
                  {...action.buttonProps}
                >
                  {action.text}
                </Button>
              ))}
            </Stack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export const withDeleteScheduledUpdateDialog =
  <T extends object>(Component: React.ComponentType<T>) =>
  (props: T) => {
    return (
      <DialogProvider context={DeleteScheduledUpdateDialogContext}>
        <Component {...(props as T)} />
      </DialogProvider>
    );
  };

export default DeleteScheduledUpdateDialog;
